import { styled, SxProps, Typography } from "@mui/material";
import { ProChip } from "./Pro/ProChip";
import { theme } from "@config/theme";

const NewChipLabel = styled(Typography)({
  fontSize: "10px",
  fontWeight: 500,
  fontFamily: "Poppins",
  color: theme.pallete.text.proChip,
  position: "relative",
  zIndex: 2,
});

const StyledProChip = styled(ProChip)({
  width: "45px",
  height: "15px",
  borderRadius: "12px",
  background: theme.pallete.background.proChip,
  "& :hover": {
    cursor: "default",
  },
});

export const NewChip = (props: { sx?: SxProps }) => {
  return (
    <StyledProChip sx={props.sx || {}}>
      <NewChipLabel>Nuevo</NewChipLabel>
    </StyledProChip>
  );
};
